import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import { styled } from '@mui/material/styles';
import { Blue } from '../../themes/blue/colorPalette';

// Customised tabs to make more appropriate for display in the TopBar
const VerticalTabs = styled(Tabs)(({ theme }) => ({
    minHeight: 0,
    '& .MuiTabs-indicator': {
        display: 'none'
    },
    '& .MuiTab-root': {
        minHeight: 0,
        borderRadius: '4px 4px 0 0',
        background: Blue[5],
        color: 'white',
        opacity: 1,
        marginRight: 4,
        '& .MuiTab-wrapper': {
            textTransform: 'none',
            padding: 4
        },
        '& .MuiSvgIcon-root': {
            fill: 'white',
            marginRight: 8,
            height: 16,
            width: 16
        },
        '&:hover': {
            backgroundColor: Blue[6],
            '& .MuiSvgIcon-root': {
                marginRight: 8
            }
        },
        '&.Mui-selected': {
            background: 'white',
            color: theme.palette.grey[2],
            '& .MuiSvgIcon-root': {
                fill: Blue[1]
            }
        }
    }
}));

VerticalTabs.propTypes = {
    children: PropTypes.node
};

export default VerticalTabs;
